import Noun from '../core/Noun';
import LinkList from './LinkList';
import { findConnection } from "../libs";
import { Response } from './Collection';

class Relationship extends Noun {
  constructor(args = {}) {
    const {
      data = {},
    } = args;

    const {
      links,
      meta = {},
      ...restData
    } = data;

    super({
      ...args,
      data: restData,
    });

    this.linkList = new LinkList({ ...args, data: links, parent: this });
    this.data = data.data;
    this._meta = data.meta ? data.meta : {};
  }

  export() {
    return {
      etag: this._etag,
      name: this.attr('name'),
      links: this.linkList.export(),
      data: this.data,
      meta: this._meta,
    };
  }

  connection() {
    return findConnection(this.parent());
  }

  id() {
    return this.attr('name');
  }

  links() {
    return this.linkList;
  }

  link(key) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }

    const link = this.linkList.item(key);

    if (!link) return null;

    return link;
  }

  meta(key) {
    if (!this._meta) {
      return undefined;
    }

    if (key === undefined) {
      throw new Error('Usage: Key is required.')
    }

    return this._meta[key];
  }

  merge(other) {
     if (!this.shouldMerge(otherList)) {
      return;
    }

    super.merge(other);

    this.linkList.merge(other.linkList);

    return this;
  }

  getRelated(args) {
    if (this.data) {
      const findResponse = (n) => {

        // If there is a parent then look for it
        if (n && n.parent && typeof n.parent === 'function' && n.parent()) {
          return findResponse(n.parent());
        }

        // Otherwise expect you have found the response and it should have an included array

        // Check to see if this has included on it
        if (n && n.included && typeof n.included === 'function') {
          return n;
        }

        // Did not find a parent with included.
        throw new Error('Invalid response: A relationship with data specified must be a child of a response with an included resources array.');
      };

      const resp = findResponse(this.parent());

      const resources = this.data.map((rio) => {
        const resource = resp.included().findResource(rio);

        if (!resource) {
          throw new Error(`Invalid response: Resource identifier object not found in included resources: ${JSON.stringify(rio)}`);
        }

        return resource.export();
      });

      let meta;
      if (resources[0]) {
        meta = resources[0].meta
      }

      let selfLink = this.attr('url');

      if (!selfLink && resources.length === 1) {
        selfLink = resources[0].links.self;
      }

      return new Response({
        parent: this,
        data: {
          data: resources,
          meta,
          links: {
            self: selfLink
          }
        },

      });
    }

    return this.link('related').get(args);
  }
}

export default Relationship;
